import { Directive, ElementRef, HostBinding, HostListener, Input, output } from '@angular/core';

@Directive({
    selector: '[fileDragDrop]',
    standalone: true
})
export class FileDragNDropDirective {
  readonly filesChangeEmitter = output<File[]>();

  @HostBinding('style.background') background = '#FFFFFF';
  @HostBinding('style.border') borderStyle = '2px dashed';
  @HostBinding('style.border-color') borderColor = '#BDC4C7';
  @HostBinding('style.border-radius') borderRadius = '8px';

  @HostListener('dragover', ['$event']) public onDragOver(evt: DragEvent){
    evt.preventDefault();
    evt.stopPropagation();
    this.background = '#eeeeee';
    this.borderColor = '#047D26';
    this.borderStyle = '3px solid';
  }

  @HostListener('dragleave', ['$event']) public onDragLeave(evt: DragEvent){
    evt.preventDefault();
    evt.stopPropagation();
    this.background = '#FFFFFF';
    this.borderColor = '#BDC4C7';
    this.borderStyle = '2px dashed';
  }

  @HostListener('drop', ['$event']) public onDrop(evt: DragEvent){
    evt.preventDefault();
    evt.stopPropagation();
    this.background = '#FFFFFF';
    this.borderColor = '#BDC4C7';
    this.borderStyle = '2px dashed';
    const valid_files: File[] = Array.from(evt.dataTransfer.files);
    this.filesChangeEmitter.emit(valid_files);
  }
}
